import { createBrowserRouter, Navigate } from "react-router-dom";
import AuthLayout from "../Components/Layouts/AuthLayout/AuthLayout";
import ProtectedLayout from "../Components/Layouts/ProtectedLayout/ProtectedLayout";
import LoginPage from "../Pages/Auth/Login/Login";
import ForgotPassword from "../Pages/Auth/ForgotPassword/ForgotPassword";
import ResetPassword from "../Pages/Auth/ResetPassword/ResetPassword";
import ConcurrentSession from "../Pages/ConcurrentSession/ConcurrentSession";
import PasswordResetSuccess from "../Pages/Auth/PasswordResetSuccessfully/PasswordResetSuccessfully";
import Add from "../Pages/CSD/Add";
import Users from "../Pages/Users/Users";
import UserProjects from "../Pages/Users/UserProjects";
import UserForm from "../Pages/Users/UserForm/UserForm";
import SalesRequests from "../Pages/SalesRequest/SalesRequest";
import UserPofile from "../Pages/UserProfile/UserProfile";
import Error from "../Pages/Error/Error";
import Forbidden from "../Pages/Error/Forbidden";
import SetPassword from "../Pages/SetPassword/SetPassword";
import Credit from "../Pages/CreditForm/CreditIndex";
import CreditCholder from "../Pages/CholderCreditForm/CreditProduct";
import PrepaidCholder from "../Pages/CholderPrepaidForm/PrepaidCholderIndex";
import FormSuccessPage from "../Pages/CSD/FormSuccess";
import ViewFormSummary from "../Pages/ReviewScreens/ViewFormSummary";
import ApiAuth from "../Pages/ApiAuth/ApiAuth";
const router = createBrowserRouter([
  {
    path: "/",
    errorElement: <h2>Error</h2>,
    element: <ProtectedLayout />,
    children: [
      {
        path: "",
        errorElement: <h2>Error</h2>,
        element: <Navigate to={"/sales"} replace />,
      },
      {
        path: "/impl",
        errorElement: <h2>Error</h2>,
        element: <SalesRequests />,
      },
      {
        path: "/concurrent-sessions",
        errorElement: <h2>Error</h2>,
        element: <ConcurrentSession />,
      },
      {
        path: "/forms/users/:id",
        errorElement: <h2>Error</h2>,
        element: <UserProjects />,
      },

      {
        path: "/users/add",
        errorElement: <h2>Error</h2>,
        element: <UserForm />,
        // access: ["admin", "super_admin"],
      },
      {
        path: "/users/:id",
        errorElement: <h2>Error</h2>,
        element: <UserForm />,
        // access: ["admin", "super_admin"],
      },
      {
        path: "/users",
        errorElement: <h2>Error</h2>,
        element: <Users />,
        // access: ["admin", "super_admin"],
      },
      {
        path: "/debit/edit/:id",
        errorElement: <h2>Error</h2>,
        element: <Add />,
      },
      {
        path: "/debit/view/:id",
        errorElement: <h2>Error</h2>,
        element: <ViewFormSummary />,
      },
      {
        path: "/credit/view/:id",
        errorElement: <h2>Error</h2>,
        element: <ViewFormSummary />,
      },
      {
        path: "/debit/success/:id",
        errorElement: <h2>Error</h2>,
        element: <FormSuccessPage />,
      },
      {
        path: "/debit/add",
        errorElement: <h2>Error</h2>,
        element: <Add />,
        access: ["1", "2", "3", "4"],
      },
      {
        path: "/credit/add",
        errorElement: <h2>Error</h2>,
        element: <Credit />,
        access: ["1", "2", "3", "4"],
      }, 
      {
        path: "/credit/edit/:id",
        errorElement: <h2>Error</h2>,
        element: <Credit />,
      },
      {
        path: "/credit/success/:id",
        errorElement: <h2>Error</h2>,
        element: <FormSuccessPage />,
      },
      {
        path: "/cholder/credit/add",
        errorElement: <h2>Error</h2>,
        element: <CreditCholder />,
        access: ["1", "2", "3", "4"],
      },
      {
        path: "/cholder/credit/edit/:id",
        errorElement: <h2>Error</h2>,
        element: <CreditCholder />,
      },
      {
        path: "/cholder/debit/add",
        errorElement: <h2>Error</h2>,
        element: <PrepaidCholder />,
        access: ["1", "2", "3", "4"],
      },
      {
        path: "/cholder/debit/edit/:id",
        errorElement: <h2>Error</h2>,
        element: <PrepaidCholder />,
      },
      {
        path: "/sales",
        errorElement: <h2>Error</h2>,
        element: <SalesRequests />,
      },
      {
        path: "/profile",
        errorElement: <h2>Error</h2>,
        element: <UserPofile />,
      },
      {
        path: "/set-password",
        errorElement: <h2>Error</h2>,
        element: <SetPassword />,
      },
      {
        path: "/forbidden",
        errorElement: <h2>Error</h2>,
        element: <Forbidden />,
      },
      {
        path: "/not-found",
        errorElement: <h2>Error</h2>,
        element: <Error />,
      },
      {
        path: "*",
        errorElement: <h2>Error</h2>,
        element: <Navigate to={"/not-found"} replace />,
      },
    ],
  },
  {
    path: "/",
    element: <AuthLayout />,
    errorElement: <h2>Error</h2>,
    children: [
      {
        path: "/login",
        errorElement: <h2>Error</h2>,
        element: <LoginPage />,
      },
      {
        path: "/forgot-password",
        errorElement: <h2>Error</h2>,
        element: <ForgotPassword />,
      },
      {
        path: "/reset-password/:id",
        errorElement: <h2>Error</h2>,
        element: <ResetPassword />,
      },
      {
        path: "/reset-success",
        errorElement: <h2>Error</h2>,
        element: <PasswordResetSuccess />,
      },
      {
        path: "*",
        errorElement: <h2>Error</h2>,
        element: <Navigate to={"/login"} replace />,
      },
    ],
  },
  {
    path: "/app-auth",
    element: <ApiAuth />,
  },
]);

export default router;
